export var IFramePlayerEvent;
(function (IFramePlayerEvent) {
    IFramePlayerEvent["ON_UTAG_DATA_REQUEST_FROM_IFRAME"] = "IFramePlayerEvent.ON_UTAG_DATA_REQUEST_FROM_IFRAME";
    IFramePlayerEvent["ON_MVP_PARENT_UTAG_DATA_RECEIVED"] = "IFramePlayerEvent.ON_MVP_PARENT_UTAG_DATA_RECEIVED";
    IFramePlayerEvent["ON_UTAG_IMPORT_REQUEST"] = "IFramePlayerEvent.ON_UTAG_IMPORT_REQUEST";
    IFramePlayerEvent["ON_UTAG_IMPORT_SUCCESS"] = "IFramePlayerEvent.ON_UTAG_IMPORT_SUCCESS";
    IFramePlayerEvent["ON_SMART_TAG_IMPORT_REQUEST"] = "IFramePlayerEvent.ON_SMART_TAG_IMPORT_REQUEST";
    IFramePlayerEvent["ON_SMART_TAG_IMPORT_SUCCESS"] = "IFramePlayerEvent.ON_SMART_TAG_IMPORT_SUCCESS";
    IFramePlayerEvent["ON_SMART_TAG_READY_CALLBACK"] = "IFramePlayerEvent.ON_SMART_TAG_READY_CALLBACK";
    IFramePlayerEvent["ON_COMPANION_PARAMS_RECEIVED"] = "IFramePlayerEvent.ON_COMPANION_PARAMS_RECEIVED";
    IFramePlayerEvent["ON_TAG_CREATE_REQUEST"] = "IFramePlayerEvent.ON_TAG_CREATE_REQUEST";
    IFramePlayerEvent["ON_TAG_CREATE_SUCCESS"] = "IFramePlayerEvent.ON_TAG_CREATE_SUCCESS";
    IFramePlayerEvent["ON_DOM_READ_PARAMS_REQUEST"] = "IFramePlayerEvent.ON_DOM_READ_PARAMS_REQUEST";
    IFramePlayerEvent["ON_DOM_READ_PARAMS_SUCCESS"] = "IFramePlayerEvent.ON_DOM_READ_PARAMS_SUCCESS";
    IFramePlayerEvent["ON_VIDEO_LOAD_REQUEST"] = "IFramePlayerEvent.ON_VIDEO_LOAD_REQUEST";
    IFramePlayerEvent["ON_POST_MESSAGE_HUB_READY"] = "IFramePlayerEvent.ON_POST_MESSAGE_HUB_READY";
    IFramePlayerEvent["ON_READY"] = "IFramePlayerEvent.ON_READY";
    IFramePlayerEvent["ON_ERROR"] = "IFramePlayerEvent.ON_ERROR";
})(IFramePlayerEvent || (IFramePlayerEvent = {}));
export const iframePlayerEvents = () => {
    const out = [];
    Object.keys(IFramePlayerEvent).forEach((key) => {
        out.push(IFramePlayerEvent[key]);
    });
    return out;
};
